import { useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import { Grid } from "../components/Grid";
import { getDataRoles2 } from "../services/getDataRoles2";
import { SinDatos } from "../components/SinDatos";

//Importación Estilos
import styles from "../css/general.module.css";

export function VistaGrid() {
  const [loading, setLoading] = useState(true);
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    let rutas = [
      {
        title: "🏛️ Inicio",
        rol: "",
        level: 1,
      },
    ];
    setLoading(true); //Se carga con TRUE para que se muestre el sppiner
    sessionStorage.setItem("RUTAS", JSON.stringify(rutas));

    getDataRoles2()
      .then((data) => {
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (error) {
            data = [];
          }
        }
        sessionStorage.setItem(`${new Date().toLocaleDateString()}-VISTAINICIAL`, JSON.stringify(data));
        setDatos(data);
        setLoading(false);
        document.getElementById("title").innerHTML = "🏛️ Inicio";
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <div className={styles.outlet}>
      {loading ? (
        <div className={styles.containerSppiner}>
          <PulseLoader className={styles.sppiner} color="#005dc9" size={50} />
        </div>
      ) : (
        <>
          {datos.length > 0 && datos[0].hasOwnProperty("id") ? (
            <Grid datos={datos} />
          ) : (
            <SinDatos />
          )}
        </>
      )}
    </div>
  );
}
